module.exports = new __parcel__URL__("righteousprivilege.01d6ed9f.png").toString();